"use client";
import { useEffect, useState } from "react";
import Image from "next/image";
import { AnimatePresence, motion, useAnimation } from "framer-motion";
import { Button } from "../ui/button";
import { useRouter } from "next/navigation";
import { useBlogStore } from "@/zustand/blogStore";
import { useProductListingStore } from "@/zustand/productListingStore";

interface ImageType {
  id: number;
  image: string;
  alt: string;
  isButtonNeedToShow: boolean;
  title: React.ReactNode;
  btnUrl?: string;
  blogId?: number;
  categoryId?: number;
  subCategoryId?: number;
  mobileImg: string;
}

const images: ImageType[] = [
  // {
  //   id: 1,
  //   image: "/images/hero-banner-web-offer.jpg",
  //   alt: "hero1",
  //   isButtonNeedToShow: true,
  //   btnUrl: "/blog/e-raffle-draw-results-january-2026",
  //   blogId: 11440,
  //   // btnUrl: "https://geminiuae.com/blog/why-gbm-is-the-go-to-choice-for-government/11440",
  //   // title: "GBM in Partnership with Jotun Opens Next-Gen Multicolor Center in the UAE.",
  //   title: (
  //     <>
  //       Join our Celebrations as we near 30 Years <br className="hidden lg:inline-block" />
  //        of Trust, Reliability & Excellence.
  //     </>
  //   ),
  //   mobileImg: "/images/hero-banner-mob-offer.jpg",

  // },
  {
    id: 1,
    image: "/images/hero-banner-web-dummy.webp",
    alt: "Gemini Partnership with Jotun - Next-Gen Multicolor Center",
    isButtonNeedToShow: false,
    title: (
      <>
        GBM in Partnership with Jotun Opens Next-Gen{" "}
        <br className="hidden lg:inline-block" /> Multicolor Center in the UAE.
      </>
    ),
    mobileImg: "/images/hero-banner-mob-dummy.webp",
  },
  {
    id: 2,
    image: "/images/hero-banner-products.webp",
    alt: "Leading Supplier of Gypsum Boards in UAE and GCC",
    btnUrl: "/product-category/ceiling-system",
    categoryId: 68,
    subCategoryId: 51,
    isButtonNeedToShow: true,
    title: (
      <>
        Largest Supplier of Gypsum boards In UAE <br className="hidden lg:inline-block" /> and
        across the GCC Region
      </>
    ),
    mobileImg: "/images/hero-banner-products-mob.webp",
  },
  {
    id: 3,
    image: "/images/hero-banner-tools-web.webp",
    alt: "Power Tools and Construction Hardware in UAE",
    btnUrl: "/product-category/hardware",
    categoryId: 1378,
    subCategoryId: 1526,
    isButtonNeedToShow: true,
    title: (
      <>
        Largest assortment of Power Tools 
        <br className="hidden lg:inline-block" />for the
        construction industry
      </>
    ),
    mobileImg: "/images/hero-banner-tools-mob.webp",
  },
];

export default function HeroSection() {
  const router = useRouter();

  const setBlogId = useBlogStore((state) => state.setBlogId);
  const { setCategoryIdToStore, setSubCategoryIdToStore } = useProductListingStore();

  // const [trackImg, setTrackImg] = useState<ImageType>(images[0]);
  const [currentSlide, setCurrentSlide] = useState(0);

  // hero landing animation – skip on mobile for faster LCP and lower TBT (default mobile so first paint is visible)
  const controls1 = useAnimation();
  const controls3 = useAnimation();
  const [reduceMotion, setReduceMotion] = useState(true);

  useEffect(() => {
    setReduceMotion(typeof window !== "undefined" && window.innerWidth < 768);
  }, []);

  useEffect(() => {
    if (reduceMotion) {
      controls1.set({ opacity: 1 });
      controls3.set({ opacity: 1 });
      return;
    }
    const animateStory = async () => {
      try {
        await controls1.start({
          opacity: 1,
          transition: { duration: 0.25, ease: "easeOut" },
        });
        await controls3.start({
          opacity: 1,
          transition: { duration: 0.15 },
        });
      } catch (error) {
        console.log('Animation error:', error);
      }
    };
    animateStory();
  }, [controls1, controls3, reduceMotion]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setTrackImg((prev) => {
  //       const currentIndex = images.findIndex((img) => img === prev);
  //       const nextIndex = (currentIndex + 1) % images.length;
  //       return images[nextIndex];
  //     });
  //   }, 6000);

  //   return () => clearInterval(interval);
  // }, [trackImg]);

  const handleHeroMainSliderPrevClick = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };
  const handleNextHeroMainSliderClick = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  const currentImage = images[currentSlide];

  return (
    <div className="pt-mob-50 sm:pt-tab-65 lg:pt-web-95">
      <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto ">
        <div className=" mb-mob-43 sm:mb-tab-43 lg:mb-web-51">
          <motion.h1
            className="relative text-center text-TitleBlack w-full text-mob-28 sm:text-tab-32 lg:text-web-50 leading-[110%] lg:leading-[120%] tracking-[0.29vw] sm:tracking-[0.166vw] lg:tracking-[0.10vw] capitalize font-normal mb-mob-20 sm:mb-tab-20 lg:mb-web-15"
            initial={{ opacity: 1, y: 0 }}
          >
            <div
              className="absolute left-mob-0 sm:left-tab-16 lg:left-web-76 z-[2] top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={handleHeroMainSliderPrevClick}
            >
              <div className="w-mob-11 sm:w-tab-15 lg:w-web-15">
                <Image
                  src="/images/chevron-left-blue.svg"
                  alt="Previous"
                  width={15}
                  height={15}
                  className="w-full h-auto"
                />
              </div>
            </div>
            {/* next btn */}
            <div
              className="absolute right-mob-1 sm:right-tab-16 lg:right-web-76 z-[2] top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={handleNextHeroMainSliderClick}
            >
              <div className="w-mob-11 sm:w-tab-15 lg:w-web-15">
                <Image
                  src="/images/chevron-right-blue.svg"
                  alt="Next"
                  width={15}
                  height={15}
                  className="w-full h-auto"
                />
              </div>
            </div>
            <AnimatePresence mode="wait">
              <motion.div
                key={currentImage.id}
                initial={{ opacity: 1 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.25 }}
                className="px-mob-30">
                <div
                  onClick={() => {
                    if (currentImage.isButtonNeedToShow && currentImage.btnUrl) {
                      router.push(currentImage.btnUrl);
                      if(currentImage.blogId){
                        setBlogId(currentImage.blogId);
                      }
                      if(currentImage.categoryId){
                        setCategoryIdToStore(currentImage.categoryId);
                        setSubCategoryIdToStore(0);
                        if(currentImage.subCategoryId){
                          setSubCategoryIdToStore(currentImage.subCategoryId);
                        }
                      }
                    }
                  }}
                  className={currentImage.isButtonNeedToShow ? "cursor-pointer inline-block" : ""}
                >
                  {currentImage.title}
                </div>

                {/* {trackImg.id === 1 && (
                  <>
                    GBM in Partnership with Jotun Opens Next-Gen{" "}
                    <br className="hidden lg:block" /> Multicolor Center in the
                    UAE.
                  </>
                )} */}
                {/* {trackImg.id === 2 && (
                  <>
                    Largest Supplier of Gypsum boards In UAE{" "}
                    <br className="hidden lg:block" />
                    and across the GCC Region
                  </>
                )} */}
                {/* {trackImg.id === 3 && (
                  <>
                    Largest assortment of Power Tools{" "}
                    <br className="hidden lg:block" /> for the construction
                    industry
                  </>
                )} */}
                {/* Add more cases here */}
              </motion.div>
            </AnimatePresence>
          </motion.h1>
          <AnimatePresence mode="wait">
            <motion.div
              key={currentImage.id} // IMPORTANT: key must change on content change
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.77 }}
            // animate={controls3}
            >
              <Button
                variant={"secondaryLinkBtnBlue"}
                className={currentImage.isButtonNeedToShow ? "" : "invisible"}
                aria-label={`Know more about ${currentImage.alt}`}
                onClick={() => {
                  if (currentImage.btnUrl) {
                    router.push(currentImage.btnUrl);
                    if(currentImage.blogId){
                      setBlogId(currentImage.blogId);
                    }
                    if(currentImage.categoryId){
                      setCategoryIdToStore(currentImage.categoryId);
                      setSubCategoryIdToStore(0);
                      if(currentImage.subCategoryId){
                        setSubCategoryIdToStore(currentImage.subCategoryId);
                      }
                    }
                  }
                }}
              >
                Know More
                <div className="w-mob-7 sm:w-tab-7 lg:w-web-7 h-auto">
                  <Image
                    src="/images/chevron-right-blue.svg"
                    alt=""
                    aria-hidden="true"
                    width={7}
                    height={10}
                    className="w-full h-auto"
                  />
                </div>
              </Button>
            </motion.div>
          </AnimatePresence>
        </div>
        <motion.div
          className="wrap-original-transform"
          style={{
            perspective: 2000,
            transformStyle: "preserve-3d",
          }}
        >
          <motion.div
            className="relative before:content-[''] before:absolute before:h-full before:w-[15.69%] before:z-[1] before:left-0  
                after:content-[''] after:absolute after:h-full after:w-[15.69%] after:z-[1] after:right-0 after:top-0 overflow-hidden rounded-mob-10 sm:rounded-tab-10 lg:rounded-web-10"
            initial={reduceMotion ? { opacity: 1 } : { opacity: 0 }}
            animate={controls1}
          >
            <AnimatePresence mode="wait">
              <motion.div
                key={currentImage.id}
                initial={{ opacity: 0.85 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0.85 }}
                transition={{ duration: 0.4 }}
                onClick={() => {
                  if (currentImage.isButtonNeedToShow && currentImage.btnUrl) {
                    router.push(currentImage.btnUrl);
                    if (currentImage.blogId) {
                      setBlogId(currentImage.blogId);
                    }
                    if (currentImage.categoryId) {
                      setCategoryIdToStore(currentImage.categoryId);
                      setSubCategoryIdToStore(0);
                      if (currentImage.subCategoryId) {
                        setSubCategoryIdToStore(currentImage.subCategoryId);
                      }
                    }
                  }
                }}
                className={
                  currentImage.isButtonNeedToShow
                    ? "cursor-pointer relative w-full h-full"
                    : "relative w-full h-full"
                }
              >
                {/* Desktop Image */}
                <div className="hidden lg:block relative w-full aspect-[3440/1240]">
                  <Image
                    src={currentImage.image}
                    alt={currentImage.alt}
                    fill
                    priority
                    fetchPriority="high"
                    sizes="(max-width: 1024px) 100vw, 90vw"
                    className="object-cover object-center rounded-web-10"
                  />
                </div>
                {/* Mobile/Tablet Image */}
                <div className="block lg:hidden relative w-full aspect-[860/1160] sm:aspect-[3440/1084]">
                  <Image
                    src={currentImage.mobileImg}
                    alt={currentImage.alt}
                    fill
                    priority
                    fetchPriority="high"
                    sizes="(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 100vw"
                    className="object-cover object-center rounded-mob-10 sm:rounded-tab-10"
                  />
                </div>
              </motion.div>
            </AnimatePresence>
            {/* prev btn */}
            {/* <div
              className="absolute left-mob-16 sm:left-tab-16 lg:left-web-76 z-[2] top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={handleHeroMainSliderPrevClick}
            >
              <div className="w-mob-15 sm:w-tab-15 lg:w-web-15 h-auto">
                <Image
                  src="/images/chevron-left-yellow.svg"
                  alt="Previous"
                  fill
                  className="!static"
                />
              </div>
            </div>
            <div
              className="absolute right-mob-16 sm:right-tab-16 lg:right-web-76 z-[2] top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={handleNextHeroMainSliderClick}
            >
              <div className="w-mob-15 sm:w-tab-15 lg:w-web-15 h-auto">
                <Image
                  src="/images/chevron-right-yellow.svg"
                  alt="Previous"
                  fill
                  className="!static"
                />
              </div>
            </div> */}
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}
